import type { ComponentProps } from 'react'

import { ChatCircleIcon, EyeIcon, ThumbsUpIcon } from '@/components/icons/icon-set'
import { cn } from '@/lib/utils'

interface PostEngagementProps extends ComponentProps<'div'> {
    views: string
    likes: string
    comments: string
}

/*
 * GoodUnited / PostEngagement. Figma: 10 / Components / PostEngagement.
 * Views, likes and comments for a social post, in Roboto / text-xs with 14px icons.
 */
function PostEngagement({ views, likes, comments, className, ...props }: PostEngagementProps) {
    const items = [
        { icon: EyeIcon, value: views, label: 'views' },
        { icon: ThumbsUpIcon, value: likes, label: 'likes' },
        { icon: ChatCircleIcon, value: comments, label: 'comments' }
    ]

    return (
        <div
            data-slot='post-engagement'
            className={cn('flex items-center gap-3 text-xs text-text-secondary', className)}
            {...props}
        >
            {items.map(({ icon: Icon, value, label }) => (
                <span key={label} className='inline-flex items-center gap-1'>
                    <Icon className='size-3.5 text-icon-secondary' aria-hidden='true' />
                    {value}
                    <span className='sr-only'>
                        {label}
                    </span>
                </span>
            ))}
        </div>
    )
}

export { PostEngagement }
